import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Validation } from '../../shared/services/validation.service';
import { ApplicationActions } from '../../actions/application.actions';
import { NgRedux } from '@angular-redux/store';
import * as _ from 'lodash';

@Component({
  selector: 'md-file-input',
  template: require('./file-input.component.html'),
  styles: [require('./file-input.component.scss')]
})

export class FileInputComponent {
  @Input() options;
  @Input() showUp;
  @Output() valueChange = new EventEmitter();
  @ViewChild('fileInput') fileInput : HTMLElement;

  file;
  isValid = true;

  constructor(validation: Validation, appActions: ApplicationActions, ngRedux: NgRedux) {
    this.validation = validation;
    this.appActions = appActions;
    this.ngRedux = ngRedux;

    this.validateSub = this.validation.validateInput.subscribe(event => this.triggerValidation());
  }

  ngOnInit() {
    if (this.options.inputPath) {
      this.reduxObservable$ = this.ngRedux.select(state => _.get(state, `applicationStore.${this.options.inputPath}`));
      this.reduxSubscription = this.reduxObservable$.subscribe(state => {
        this.file = state || null;
      });
    }
  }

  selectFile(event) {
    event.preventDefault();
    this.fileInput.nativeElement.click();
  }

  triggerValidation() {
    const isValidObj = this.validation.validate(this.options.validationType, this.file);
    if (isValidObj != null) {
      this.isValid = isValidObj.state;
      if (!this.isValid) {
        this.options.msg = this.options.msg || {};
        if (isValidObj.msg) this.options.msg.fail = isValidObj.msg;
      } else {
        this.options.msg = undefined;
      }
      let isValid = this.isValid;
      if (this.showUp === false) {
        isValid = true;
      }
      this.validation.validCheck({
        id: this.options.attr.id,
        isValid
      });
    }
  }

  onChange(event) {
    if (event.target.files[0]) {
      this.file = event.target.files[0];
    } else {
      this.file = null;
    }

    const value = this.file ? {
      name: this.file.name,
      size: this.file.size,
      title: this.options.title,
      id: this.options.attr.id,
      path: this.options.inputPath,
      file: this.file
    } : null;

    this.triggerValidation();

    if (this.isValid && this.options.inputPath) {
      this.appActions.setData(this.options.inputPath, value);
    }
  }

  ngOnDestroy() {
    if (this.validateSub) {
      this.validateSub.unsubscribe();
    }

    if (this.options.inputPath) {
      this.reduxObservable$.unsubscribe();
      this.reduxSubscription.unsubscribe();
    }
  }
}
